var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"ai-btn",on:{"click":_vm.onAiButtonClick}},[_vm._v("AI助手")])])
}
var staticRenderFns = []

export { render, staticRenderFns }